import React from 'react';
import { Container } from 'react-bootstrap';
import TeamMember from './TeamMember';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Team.css'

const TeamSection = () => {
  // Sample data for team members - DÉPLACÉ À L'INTÉRIEUR DU COMPOSANT
  const teamMembers = [
    { id: 1, name: 'Babacar', role: 'Cofondateur', imageUrl: 'me.jpg' },
    { id: 2, name: 'Néné', role: 'Developpeuse FullStack', imageUrl: 'neneba.jpg' },
    { id: 3, name: 'Marie', role: 'Cofondatrice', imageUrl: 'marie.jpg' },
    { id: 4, name: 'Hamid', role: 'Infographiste', imageUrl: 'leuz.jpg' },
    { id: 5, name: 'Faty', role: 'Developpeurse FullStack', imageUrl: 'soum.jpeg' },
    // Add more team members as needed
  ];

  // Settings for the slider - DÉPLACÉ À L'INTÉRIEUR DU COMPOSANT
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  // Function to render team member items
  const renderTeamMembers = () => {
    return teamMembers.map(member => (
        <div key={member.id} className="px-2">
          <TeamMember member={member} />
        </div>
    ));
  };

  return (
      <div className="team-section-tech">
        {/* Effets de fond */}
        <div className="team-background-grid"></div>
        <div className="team-binary-rain">
          {[...Array(20)].map((_, i) => (
              <div
                  key={i}
                  className="binary-code"
                  style={{
                    left: `${Math.random() * 100}%`,
                    animationDelay: `${Math.random() * 10}s`
                  }}
              >
                {Math.random() > 0.5 ? '1' : '0'}
              </div>
          ))}
        </div>

        <Container className="mt-5 mb-5">
          {/* Header technologique */}
          <div className="team-tech-header">
            <div className="team-title-container">
              <h2 className="team-tech-title">Notre équipe</h2>
              <div className="team-title-glow">Notre équipe</div>
            </div>

            <div className="team-title-border">
              <div className="title-border-inner"></div>
            </div>

            <p className="team-subtitle">
              Les membres de ACT et leurs profils
            </p>
          </div>

          {/* Statistiques */}
          <div className="team-stats-grid">
            <div className="team-stat-card">
              <div className="stat-glow"></div>
              <div className="stat-number">5</div>
              <div className="stat-label">Membres</div>
            </div>
            <div className="team-stat-card">
              <div className="stat-glow"></div>
              <div className="stat-number">10</div>
              <div className="stat-label">Projets</div>
            </div>
            <div className="team-stat-card">
              <div className="stat-glow"></div>
              <div className="stat-number">99.9</div>
              <div className="stat-label">Satisfaction</div>
            </div>
          </div>

          {/* Slider avec effet technologique */}
          <div className="team-slider-container">
            <div className="slider-track"></div>
            <div className="slider-track track-particles">
              {[...Array(10)].map((_, i) => (
                  <div
                      key={i}
                      className="track-particle"
                      style={{
                        animationDelay: `${i * 0.3}s`
                      }}
                  ></div>
              ))}
            </div>

            <Slider {...sliderSettings}>
              {teamMembers.map(member => (
                  <div key={member.id}>
                    <div className="team-member-card-tech">
                      <div className="member-hologram"></div>
                      <div className="member-connection-points">
                        <div className="connection-point" style={{top: '20%', left: '10%'}}></div>
                        <div className="connection-point" style={{top: '20%', right: '10%'}}></div>
                        <div className="connection-point" style={{bottom: '20%', right: '10%'}}></div>
                        <div className="connection-point" style={{bottom: '20%', left: '10%'}}></div>
                      </div>

                      <div className="member-card-inner">
                        <div className="member-badges">
                          <div className="member-badge">Tech Lead</div>
                        </div>

                        <div className="member-avatar-container">
                          <div className="avatar-hologram"></div>
                          <img
                              src={member.imageUrl}
                              alt={member.name}
                              className="member-avatar"
                          />
                          <div className="avatar-ring"></div>
                        </div>

                        <div className="member-info-tech">
                          <h3 className="member-name-tech">{member.name}</h3>
                          <div className="member-role-tech">{member.role}</div>
                          <div className="member-role-tech">{member.desc}</div>

                          <div className="member-tech-stack">

                          </div>

                          <div className="member-stats">
                            <div className="member-stat">
                              <div className="stat-icon">⚡</div>
                              <div className="stat-value">98%</div>
                              <div className="stat-label">Efficacité</div>
                            </div>
                            <div className="member-stat">
                              <div className="stat-icon">🚀</div>
                              <div className="stat-value">50+</div>
                              <div className="stat-label">Projets</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              ))}
            </Slider>
          </div>
        </Container>
      </div>
  );
};

export default TeamSection;